import { Injectable } from '@angular/core';
import { ValidatorService as M1ValidatorsService } from '@m1/components';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ValidatorsService extends M1ValidatorsService {
  constructor(private translate: TranslateService) {
    super();
  }

  /**
   * Retrieves the translated validation message dynamically.
   */
  override getValidationMessage(
    key: string,
    fieldName: string,
    length?: number
  ): string {
    let translationKey = `VALIDATIONS.${key.toUpperCase()}`;

    // Fetch the translated message
    let message =
      this.translate.instant(translationKey) ||
      this.translate.instant('VALIDATIONS.UNEXPECTED_ERROR');

    // If the message contains placeholders, replace them with actual values
    return message
      .replace('{0}', fieldName.toLocaleLowerCase())
      .replace('{1}', length?.toString() ?? '');
  }

  /**
   * Determines the correct validation error message for a form field.
   */
  override getErrorMessage(fieldName: string, c: any): string {
    if (c.errors) {
      const errorKey = Object.keys(c.errors)[0]; // Get the first error key
      const errorValue = c.errors[errorKey]; // Get error details (like min/max length)

      return this.getValidationMessage(
        errorKey,
        fieldName,
        errorValue?.requiredLength
      );
    }
    return '';
  }
}
